import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { CAMPAIGN_HISTORY_REPORT_ID } from './campaignHistoryReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.CHANGE_TIME.field,
        FIELDS.CAMPAIGN_NAME.field,
        FIELDS.ACTIVITY.field,
        FIELDS.ACTIVITY_DETAILS.field,
        FIELDS.OLD_VALUE.field,
        FIELDS.NEW_VALUE.field,
        FIELDS.PERFORMER.field,
    ].map(field => generateColumnId(CAMPAIGN_HISTORY_REPORT_ID, field)),
};
const defaultColumns = [
    FIELDS.CHANGE_TIME.field,
    FIELDS.CAMPAIGN_NAME.field,
    FIELDS.ACTIVITY.field,
    FIELDS.ACTIVITY_DETAILS.field,
    FIELDS.OLD_VALUE.field,
    FIELDS.NEW_VALUE.field,
    FIELDS.PERFORMER.field,
].map(field => generateColumnId(CAMPAIGN_HISTORY_REPORT_ID, field));

export { customColumns, defaultColumns };
